module.exports = __webpack_public_path__ + "img/whistle.93e6fc6f.svg";